export default {
  handleErrosColaborador(errorData) {
    return {
      cpf: errorData?.cpf?.[0] || '',
      nome: errorData?.nome?.[0] || '',
      genero: errorData?.genero?.[0] || '',
      data_nascimento: errorData?.data_nascimento?.[0] || '',
      setor: errorData?.setor?.[0] || '',
      matricula: errorData?.matricula?.[0] || '',
      id_categoria: errorData?.id_categoria?.[0] || '',
      nome_mae: errorData?.nome_mae?.[0] || '',
      id_nacionalidade: errorData?.id_nacionalidade?.[0] || '',
      error: errorData?.error?.[0] || '',
    };
  }
};
